export function sliceCharacters(text: string, characterAmount = 25) {
  const shouldSliceCharacters = text.length > characterAmount;

  return shouldSliceCharacters ? `${text.slice(0, characterAmount)}...` : text;
}
